(function ($) {

  const $body = $('body');
  const $header = $('#site-header');
  const $menu = $('#menu-wrap');
  const $toggle = $('#mobile-menu-toggle');
  const $collapsibleHeaderRows = $header.find('.header-top, .header-main > .container-fluid');
  const speed = 300;
  const scrollThreshold = 8;
  const scrollDirectionThreshold = 24;
  let scrollAnchor = Math.max(window.pageYOffset, 0);
  let scrollTicking = false;
  let resizeFrame = null;
  let resizePaintFrame = null;
  let breakpointResizeTimer = null;
  let headerRowsCollapsed = false;
  let headerRowsResizing = false;

  const menu_bp = $header.data('menu-bp');
  const $topLevelItems = () => $menu.find('ul.menu > li.menu-item-has-children');


  function is_mobile() {
    return $toggle.is(':visible');
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap($header.get(0), {
    onActivate() {
      console.log("activated");
      $toggle.addClass('is-active');
      $menu.addClass('visible');
      $body.addClass('menu-open');
    },
    onDeactivate() {
      console.log("deactivated");
      $toggle.removeClass('is-active');
      $body.removeClass('menu-open');
      setTimeout(function () {
        $menu.removeClass('visible');
      }, speed);
    },
    initialFocus: $toggle.get(0),
  });


  function resize(resetScrollState = false) {
    // console.log(menu_bp, !ThemeJS.Media_Queries.is_at_least( 'lg' ));
    if (resetScrollState || $body.hasClass('menu-open') || window.pageYOffset <= scrollThreshold) {
      headerRowsCollapsed = false;
    }

    window.cancelAnimationFrame(resizeFrame);
    window.cancelAnimationFrame(resizePaintFrame);
    headerRowsResizing = true;
    $header.addClass('header-rows-measuring');
    $header.toggleClass('mobile', !ThemeJS.Media_Queries.is_at_least(menu_bp));
    $header.removeClass('header-rows-collapsed');

    $collapsibleHeaderRows.each(function (index) {
      $header.get(0).style.removeProperty(`--collapsible-header-row-${index}-height`);
    });

    // Force responsive styles to settle before measuring each row at its natural height.
    $header.get(0).offsetHeight;

    $collapsibleHeaderRows.each(function (index) {
      $header.get(0).style.setProperty(`--collapsible-header-row-${index}-height`, `${$(this).outerHeight()}px`);
    });
    document.querySelector(':root').style.setProperty('--header-height', `${$header.outerHeight()}px`);

    // Keep transitions disabled until the resized state has been painted.
    resizeFrame = window.requestAnimationFrame(function () {
      resizePaintFrame = window.requestAnimationFrame(function () {
        $header.removeClass('header-rows-measuring');
        scrollAnchor = Math.max(window.pageYOffset, 0);
        headerRowsResizing = false;
        resizeFrame = null;
        resizePaintFrame = null;
      });
    });

    $menu.removeClass('mobile-transition-enabled');
    setTimeout(function () {
      $menu.addClass('mobile-transition-enabled');
    }, 0);
    if (ThemeJS.Media_Queries.is_at_least(menu_bp)) {
      focus_trap.deactivate();
      reset_mobile_submenu_styles();
      $topLevelItems().each(function () {
        set_desktop_megamenu_open($(this), false);
      });
    } else {
      reset_mobile_submenu_styles();
      $topLevelItems().each(function () {
        set_desktop_megamenu_open($(this), false);
        set_submenu_open($(this), false);
      });
    }
  }


  // init header pad height and set header to fixed
  resize();
  $header.addClass('fixed');
  // trigger height recalculation on breakpoint change
  $(window).on('breakpoint_changed', function () {
    window.clearTimeout(breakpointResizeTimer);

    // Lock the header open immediately so resize-induced scroll events cannot
    // briefly restore the collapsed state before heights are recalculated.
    headerRowsCollapsed = false;
    headerRowsResizing = true;
    $header.addClass('header-rows-measuring');
    $header.removeClass('header-rows-collapsed');

    breakpointResizeTimer = window.setTimeout(function () {
      resize(true);
      breakpointResizeTimer = null;
    }, 50);
  });


  function set_header_rows_collapsed(collapsed) {
    if ($body.hasClass('menu-open') || window.pageYOffset <= scrollThreshold) {
      collapsed = false;
    }

    if (headerRowsCollapsed === collapsed) {
      return;
    }

    headerRowsCollapsed = collapsed;
    scrollAnchor = Math.max(window.pageYOffset, 0);
    $header.toggleClass('header-rows-collapsed', headerRowsCollapsed);
    if (headerRowsCollapsed) {
      close_all_desktop_megamenus();
    }
  }


  function handle_scroll() {
    const scrollTop = Math.max(window.pageYOffset, 0);

    if (headerRowsResizing) {
      scrollAnchor = scrollTop;
      scrollTicking = false;
      return;
    }

    if (scrollTop <= scrollThreshold) {
      set_header_rows_collapsed(false);
      scrollAnchor = scrollTop;
      scrollTicking = false;
      return;
    }

    const scrollDistance = scrollTop - scrollAnchor;

    if (!headerRowsCollapsed) {
      if (scrollDistance >= scrollDirectionThreshold) {
        set_header_rows_collapsed(true);
        scrollAnchor = scrollTop;
      } else if (scrollDistance < 0) {
        scrollAnchor = scrollTop;
      }
    } else if (scrollDistance <= -scrollDirectionThreshold) {
      set_header_rows_collapsed(false);
      scrollAnchor = scrollTop;
    } else if (scrollDistance > 0) {
      scrollAnchor = scrollTop;
    }

    scrollTicking = false;
  }


  $(window).on('scroll', function () {
    if (scrollTicking) {
      return;
    }

    scrollTicking = true;
    window.requestAnimationFrame(handle_scroll);
  });

  // toggle mobile menu on hamburger click
  $toggle.click(() => {
    set_header_rows_collapsed(false);
    $body.hasClass('menu-open') ? focus_trap.deactivate() : focus_trap.activate();
  });


  function get_link_wrap($li) {
    return $('> .link-wrap, > .megamenu-column-link-wrap', $li).first();
  }


  function get_submenu($li) {
    const $btn = get_link_wrap($li).find('button.sub-menu-toggle').first();
    if (!$btn.length) {
      return $();
    }

    return $(`#${$btn.attr('aria-controls')}`);
  }


  // function to set submenus open/close (mobile accordion only)
  function set_submenu_open($li, opening) {
    if (!$header.hasClass('mobile')) {
      return;
    }

    const $link_wrap = get_link_wrap($li);
    const $btn = $link_wrap.find('button.sub-menu-toggle').first();
    if (!$btn.length) { return; }
    let $submenu = get_submenu($li);
    if (!$submenu.length) { return; }
    $btn.attr('aria-expanded', opening ? 'true' : 'false');
    $link_wrap.find('> a.megamenu-trigger').attr('aria-expanded', opening ? 'true' : 'false');
    $submenu.attr('aria-hidden', opening ? 'false' : 'true');
    $submenu.stop(true, true)[opening ? 'slideDown' : 'slideUp'](speed);
    $li.toggleClass('submenu-open', opening);

    if (!opening) {
      $submenu.find('> li.menu-item-has-children').each(function () {
        set_submenu_open($(this), false);
      });
    }

    if (opening) {
      $link_wrap.addClass('opened-submenu');
    } else {
      $link_wrap.removeClass('opened-submenu');
    }
  }


  function reset_mobile_submenu_styles() {
    $menu.find('ul.sub-menu').stop(true, true).removeAttr('style');
    $menu.find('li.menu-item-has-children').removeClass('submenu-open');
    $menu.find('.link-wrap.opened-submenu').removeClass('opened-submenu');
  }


  function toggle_submenu($li) {
    const $btn = get_link_wrap($li).find('button.sub-menu-toggle').first();
    if (!$btn.length) {
      return;
    }

    const opening = $btn.attr('aria-expanded') === 'false';
    set_submenu_open($li, opening);
  }


  function set_desktop_megamenu_open($li, opening) {
    const $link_wrap = $('> .link-wrap', $li);
    const $btn = $('button.sub-menu-toggle', $link_wrap);
    const $trigger = $('> a.megamenu-trigger', $link_wrap);
    const $submenu = get_submenu($li);

    if (!$submenu.length) {
      return;
    }

    $li.toggleClass('megamenu-open', opening);
    $btn.attr('aria-expanded', opening ? 'true' : 'false');
    $trigger.attr('aria-expanded', opening ? 'true' : 'false');
    $submenu.attr('aria-hidden', opening ? 'false' : 'true');

    if (opening) {
      $submenu.stop(true, true).css('display', '');
    }
  }


  function toggle_desktop_megamenu($li) {
    const opening = !$li.hasClass('megamenu-open');

    $topLevelItems().not($li).each(function () {
      set_desktop_megamenu_open($(this), false);
    });
    set_desktop_megamenu_open($li, opening);
  }


  function close_all_desktop_megamenus() {
    $topLevelItems().each(function () {
      set_desktop_megamenu_open($(this), false);
    });
  }


  function toggle_top_level_submenu($li) {
    if ($header.hasClass('mobile')) {
      toggle_submenu($li);
      return;
    }

    toggle_desktop_megamenu($li);
  }


  // toggle submenus via caret button (any depth on mobile; top-level only on desktop)
  $menu.on('click', 'li.menu-item-has-children > .link-wrap button.sub-menu-toggle', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $li = $(this).closest('li.menu-item-has-children');

    if ($header.hasClass('mobile')) {
      toggle_submenu($li);
      return;
    }

    if ($li.parent('ul.menu').length) {
      toggle_top_level_submenu($li);
    }
  });


  // mobile: L2+ placeholder column headers — tap title to expand nested submenu
  $menu.on('click', 'li.megamenu-placeholder-parent > .link-wrap span.megamenu-column-title', function (e) {
    if (!$header.hasClass('mobile')) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    toggle_submenu($(this).closest('li.megamenu-placeholder-parent'));
  });


  // top-level void links open/close megamenu (desktop click, mobile accordion)
  $menu.on('click', 'ul.menu > li.menu-item-has-children > .link-wrap > a.megamenu-trigger', function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggle_top_level_submenu($(this).closest('li'));
  });


  // close submenu on tab out of the mobile menu (not when focus moves between items)
  $menu.on('focusout', 'li.menu-item-has-children', function (e) {
    if (!is_mobile()) {
      return;
    }

    // Tap-to-toggle on mobile often yields no relatedTarget.
    if (!e.relatedTarget) {
      return;
    }

    // Focus moved to another control inside the menu — keep open sections as-is.
    if ($(e.relatedTarget).closest('#menu-wrap').length) {
      return;
    }

    set_submenu_open($(this), false);
  });


  // close desktop megamenus when clicking outside
  $(document).on('click', function (e) {
    if ($header.hasClass('mobile')) {
      return;
    }

    if ($(e.target).closest('#menu-wrap ul.menu > li.menu-item-has-children').length) {
      return;
    }

    close_all_desktop_megamenus();
  });


  $(document).on('keydown', function (e) {
    if (e.key !== 'Escape' || $header.hasClass('mobile')) {
      return;
    }

    close_all_desktop_megamenus();
  });

})(jQuery);
